import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { SuperDashboardCard } from "./..";
import { useInterval } from 'ahooks';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useStyles } from "./Clock.style";
export var Clock = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    now = _useState2[0],
    setNow = _useState2[1];
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  useInterval(function () {
    return setNow(dayjs());
  }, 1000);
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ghost: true,
    ref: ref
  }, properties, {
    className: "".concat(styles.container, " ").concat(properties.className),
    bodyStyle: _objectSpread({
      background: "linear-gradient(to right, rgb(".concat(now === null || now === void 0 ? void 0 : now.format('hh, mm, ss'), "), rgb(").concat(now === null || now === void 0 ? void 0 : now.format('HH, mm, ss'), "))")
    }, properties.bodyStyle)
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 50,
      marginLeft: 15,
      fontWeight: 600,
      fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
      marginBottom: 0,
      marginTop: 28,
      lineHeight: '28px'
    }
  }, /*#__PURE__*/React.createElement("span", null, now === null || now === void 0 ? void 0 : now.format('hh:mm')), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 15,
      marginLeft: 5
    }
  }, now === null || now === void 0 ? void 0 : now.format('A'))), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 15,
      fontWeight: 500,
      fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif"
    }
  }, now === null || now === void 0 ? void 0 : now.format('dddd, MMMM Do')), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    "stroke-width": "0",
    fill: "currentColor",
    stroke: "currentColor",
    className: "ant-pro-card-body-decorator",
    style: {
      display: 6 <= ((now === null || now === void 0 ? void 0 : now.hour()) || 0) && ((now === null || now === void 0 ? void 0 : now.hour()) || 23) <= 18 ? 'none' : undefined
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
  })));
});
Clock.isProCard = true;